import config from '@config'
import { ViewportTypeValues } from '@contexts/viewport'
import { ComputedTeaserFlex } from '../types'
import { computeTeaserWidth } from '../utils'
import {
  ComputedTeaserImageWidth,
  ComputedTeaserRatio,
  TOITeaserRatios,
} from './types'

const {
  publication: { publication },
} = config

const adjustSizeIfRomandie = (size: number) =>
  publication === 'romandie' ? size * 0.87 : size

const RATIOS_TOI_TEASER: TOITeaserRatios = {
  desktop: {
    '2': '1_1',
    '3': '1_1',
    '4': '1_1',
    '6': '2_1',
  },
  tablet: {
    '3': '1_1',
    '6': '1_1',
  },
  mobile: {
    '6': '1_1',
  },
}

const computeRatio = (
  computedFlex: ComputedTeaserFlex
): ComputedTeaserRatio => {
  return {
    desktop: RATIOS_TOI_TEASER['desktop'][computedFlex['desktop']],
    tablet: RATIOS_TOI_TEASER['tablet'][computedFlex['tablet']],
    mobile: RATIOS_TOI_TEASER['mobile'][computedFlex['mobile']],
  }
}

const computeImageWidth = (
  computedFlex: ComputedTeaserFlex
): ComputedTeaserImageWidth => ({
  desktop: Math.ceil(
    computeTeaserWidth({
      viewportType: ViewportTypeValues.DESKTOP,
      flexValue: computedFlex[ViewportTypeValues.DESKTOP],
    })
  ),
  tablet: Math.ceil(
    computeTeaserWidth({
      viewportType: ViewportTypeValues.TABLET,
      flexValue: computedFlex[ViewportTypeValues.TABLET],
    })
  ),
  // iPhone 12 Pro Max viewport in pixels
  // https://yesviz.com/devices/iphone-12-pro-max/
  mobile: 428,
  mobileSmall: 320,
})

export {
  adjustSizeIfRomandie,
  RATIOS_TOI_TEASER,
  computeRatio,
  computeImageWidth,
}
